import type { PresentationModule } from '../../presentation/types';
import { etrust } from './content';
import { ETrustScene } from './scenes/ETrustScene';

export const etrustModule: PresentationModule = {
  id: 'etrust',
  label: 'eTrust',
  priority: 'secondary',
  scenes: [
    { ...etrust, module: 'etrust', create: (resolved) => new ETrustScene(resolved) },
  ],
};
